import { DehydratedState } from '@tanstack/react-query';

export function combineDehydratedStates(
  a: DehydratedState | undefined,
  b: DehydratedState | undefined
): DehydratedState {
  return {
    mutations: [...(a ? a.mutations : []), ...(b ? b.mutations : [])],
    queries: [...(a ? a.queries : []), ...(b ? b.queries : [])],
  };
}
